import { Stack } from '@mui/material';
import Container from '@mui/material/Container';

import { NotForAdminsAlert } from '@/components/NotForAdminsAlert';
import { PageTitle } from '@/components/PageTitle';
import { TetherInfoAlert } from '@/components/TetherInfoAlert';
import { AccountBalanceCard } from '@/components/subscriptions/AccountBalanceCard';
import { CurrentSubscriptionTable } from '@/components/subscriptions/CurrentSubscriptionTable';
import { PaymentEmailCard } from '@/components/subscriptions/PaymentEmailCard';
import { PaymentMethodCard } from '@/components/subscriptions/PaymentMethodCard';
import { PaymentTroubleAlert } from '@/components/subscriptions/PaymentTroubleAlert';
import { SubscriptionStatusSummaryBox } from '@/components/subscriptions/SubscriptionStatusSummaryBox';
import { UnusedLinesAlert } from '@/components/subscriptions/UnusedLinesAlert';
import { SummaryCardRow } from '@/components/ui/SummaryCard';
import { TETHER_URLS } from '@/hooks/useTetherDeviceIdentity';

export const PaymentSettingsPage = () => {
    return (
        <Container maxWidth="lg">
            <PageTitle title="Payment Settings" />
            <NotForAdminsAlert />
            <Stack sx={{ width: 1, gap: 3 }}>
                <TetherInfoAlert title="View Spotter Scout billing on Tether" href={TETHER_URLS.billing}>
                    Additional charges may apply if you increase update frequency or live controls usage. You can track
                    Scout telemetry costs on the Tether Dashboard.
                </TetherInfoAlert>
                <PaymentTroubleAlert />
                <SummaryCardRow sx={{ width: 1 }}>
                    <PaymentMethodCard />
                    <AccountBalanceCard />
                    <PaymentEmailCard />
                </SummaryCardRow>
                <SubscriptionStatusSummaryBox />
                <UnusedLinesAlert />
                <CurrentSubscriptionTable />
            </Stack>
        </Container>
    );
};
